import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {DocumentLiquidation} from '../../model/Entities/DocumentLiquidation';
import {DocumentLiquidationService} from '../../services/documentLiquidation.service';
import {SnackService} from '../../services/snack.service';
import {Document} from '../../model/Entities/Document';
import {Filter} from '../../model/Helpers/Filter';

@Component({
    selector: 'document-confirm-delete-liquidations-dialog',
    templateUrl: './document-confirm-delete-liquidations.dialog.component.html',
    styleUrls: ['./document-confirm-delete-liquidations.dialog.component.scss']
})
export class DocumentConfirmDeleteLiquidationsDialogComponent implements AfterViewInit {
    liquidation: any;


    constructor(public dialog: MatDialogRef<DocumentConfirmDeleteLiquidationsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.liquidation = data.liquidation;
    }

    ngAfterViewInit(): void {

    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentConfirmDeleteLiquidationsDialogComponent/document-confirm-delete-liquidations.dialog.component.ts